import React, { useState } from 'react';

import { BulkAddUsersContext, BulkAddUsersAttributesContext } from 'common/contexts';
import { Attribute } from 'common/constants/types';
import BulkAddAttributesContainer from './components/BulkAddAttributesContainer';
import EditorContainer from './components/EditorContainer';

const BulkAddUsersPage = () => {
  const [newMembers, setNewMembers] = useState<Record<string, unknown>[]>([{}]);
  const [bulkAttributes, setBulkAttributes] = useState<Attribute[]>([]);
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <BulkAddUsersAttributesContext.Provider value={{ bulkAttributes, setBulkAttributes }}>
      {/* eslint-disable-next-line react/jsx-no-constructed-context-values */}
      <BulkAddUsersContext.Provider value={{ newMembers, setNewMembers }}>
        <div className="bulk-add-users-page" style={{ display: 'flex' }}>
          <div style={{ width: '70vw' }}>
            <EditorContainer />
          </div>
          <div style={{ borderLeft: 'solid 1px #DDDDDD', width: '30vw' }}>
            <BulkAddAttributesContainer />
          </div>
        </div>
      </BulkAddUsersContext.Provider>
    </BulkAddUsersAttributesContext.Provider>
  );
};

export default BulkAddUsersPage;
